export default "__VITE_ASSET__8af04e7f__"